<template>
    <Editor v-model="text" :placeholder="readonly? '' : placeholder" :readonly="readonly" :editorStyle="`height: ${height}`" />
</template>

<script>
import { computed } from 'vue'
import Editor from 'primevue/editor';

export default {
    name: 'tw-editor',
    components: {
        Editor
    },
    emits: {
        'text-change': null,
        'inout': null
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? '' : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        return {
            text
        }
    },
    props: {
        modelValue: String,
        placeholder: String,
        readonly: Boolean,
        height: {
            type: String,
            default: '320px'
        }
    }
}
</script>
